<template>
  <span>
    <v-row>
      <v-col>
        <!--        {{boxSummaryData}}-->
        <table
          class="mx-auto"
          width="70%"
          border="0"
          style="border: 1px solid #cbc9c9"
        >
          <tr>
            <td width="25%" class="text-center" rowspan="2">
              <img width="75%" src="../../../../public/posta.png" />
            </td>
            <td colspan="2" class="text-center">
              <p style="font-size: 30px; font-weight: bold">Posta Uganda</p>
              <h7>P.O.BOX RENTER'S AUTHORITY CARD</h7>
            </td>
          </tr>
          <tr style="border-bottom: 1px solid #cbc9c9">
            <td width="38%">
              <h7
                ><span class="mr-4" style="font-size: 19px">Card No.</span>
                56789trertyu</h7
              >
            </td>
            <td>
              <h7
                ><span class="mr-4" style="font-size: 19px">Box. No.</span>
                {{ boxSummaryData.box_number }}</h7
              >
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #cbc9c9">
            <td
              style="border-right: 1px solid #cbc9c9"
              class="text-center"
              rowspan="6"
            >
              photo
            </td>
            <td style="height: 40px" colspan="2">
              <span class="ml-3" style="margin-right: 26%; font-weight: bold"
                >Name:</span
              >
              {{ boxSummaryData.individual_first_name }}
              {{ boxSummaryData.individual_last_name }}
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #cbc9c9">
            <td style="height: 40px" colspan="2">
              <span class="ml-3" style="margin-right: 30%; font-weight: bold"
                >Tel:</span
              >
              {{ boxSummaryData.individual_phone }}
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #cbc9c9">
            <td style="height: 40px" colspan="2">
              <span class="ml-3" style="margin-right: 27%; font-weight: bold"
                >Email:</span
              >
              {{ boxSummaryData.individual_email }}
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #cbc9c9">
            <td style="height: 40px" colspan="2">
              <span class="ml-3" style="margin-right: 20%; font-weight: bold"
                >Post Office:</span
              >
              {{ boxSummaryData.post_office_station }}
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #cbc9c9">
            <td style="height: 40px">
              <span class="ml-3 mr-15" style="font-weight: bold"
                >Issuing Officer's Signature:</span
              >
            </td>
            <td style="height: 40px" rowspan="2">
              <!--             Signature-->
            </td>
          </tr>

          <tr style="border-bottom: 1px solid #cbc9c9">
            <td style="height: 40px; font-weight: bold">
              <span class="ml-3 mr-15">Renter's Signature:</span>
            </td>
          </tr>
        </table>

        <button
          class="form-control receiptButton button mx-auto"
          style="margin-bottom: 4%; margin-top: 5%; width: 70%"
          type="submit"
        >
          Finish
          <b-spinner v-if="receiptSpinner" label="Loading..." small></b-spinner>
        </button>
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "Receipt",
  props: ["boxSummaryData"],
  data() {
    return {
      receiptSpinner: false,
    };
  },
};
</script>

<style scoped>
.receiptButton {
  width: 96%;
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 18px;
  margin-top: 4%;
}
</style>
